import { chartKeys } from 'utils/constant';

const average_trades_per_day = {
  chartTitle: 'Average Trades Per Day',
  chartKey: chartKeys.AVERAGE_TRADES_PER_DAY,
}

export default average_trades_per_day;